import angular from 'angular';

import { unitInfoPopupRoutesConfig } from './unit.info.routes';

export default angular
  .module('unit.info', ['ui.router'])
  .config(unitInfoPopupRoutesConfig);
